import React, { FC } from "react";
import { Redirect, Switch } from "react-router-dom";

import { PrincipalProps } from "./types";
import { useAbility } from "../../hooks";
import {
  principalDatabase,
  principalDatabaseView,
} from "../../config/router/routes";

export const Principal: FC<PrincipalProps> = () => {
  const ability = useAbility();

  const firstAllovedNavRoute = principalDatabaseView.routes?.find(
    (routeConfig) => {
      return routeConfig.isRedirectAllowed({
        ability,
      });
    },
  );

  return (
    <Switch>
      {firstAllovedNavRoute ? (
        <Redirect to={firstAllovedNavRoute.path} />
      ) : (
        <Redirect to={principalDatabase.path} />
      )}
    </Switch>
  );
};
